import Curation from 'components/Curation/Curation'
import SectionContent from 'components/Section/SectionContent'
import SectionTitle from 'components/Section/SectionTitle'
import SkeletonCuration from 'components/Skeleton/SkeletonCuration'
import { getConfig } from 'core/singleton'
import React, { useMemo } from 'react'
import { useRecoilValue } from 'recoil'
import styled from 'styled-components'
import { STORE_CURATION, STORE_CURATION_LOADING } from 'core/store/curation'
import { STORE_ROOT_PROPS } from 'core/store/global'
import SectionLayout from 'container/SectionLayout'
import { CUSTOM_CLASS_NAME } from 'core/constants'

interface SectionCurationProps {
  isVisible: boolean
}

const SectionCuration: React.FC<SectionCurationProps> = (props) => {
  const { isVisible } = props
  const curationList = useRecoilValue(STORE_CURATION)
  const root = useRecoilValue(STORE_ROOT_PROPS)
  const isCurationLoading = useRecoilValue(STORE_CURATION_LOADING)
  /**
   * @name DOMElement
   **/

  const curationWording = useMemo(() => {
    const { curationWording } = getConfig()
    return curationWording
  }, [])

  const skeleton = useMemo(() => {
    if (isCurationLoading) {
      return (
        <>
          <SkeletonCuration />
          <SkeletonCuration />
          <SkeletonCuration />
          <SkeletonCuration />
          <SkeletonCuration />
          <SkeletonCuration />
          <SkeletonCuration />
          <SkeletonCuration />
        </>
      )
    }
  }, [isCurationLoading])

  const curationListEl = useMemo(() => {
    return curationList.map((item) => {
      const { curationId, curationName, imageUrl } = item
      return (
        <Curation
          key={curationId}
          thumbnail={imageUrl + '?h=225&w=225&f=jpg'}
          title={curationName}
          partnerId={root?.partnerId}
          id={curationId}
        />
      )
    })
  }, [curationList, root?.partnerId])

  if (!isVisible) return <></>

  return (
    <SectionLayout
      elementId="curation"
      trigger={`${isCurationLoading}`}
      className={`${CUSTOM_CLASS_NAME.CURATION_CATEGORY}`}
    >
      <StyledSectionCuration>
        <SectionTitle className={`${CUSTOM_CLASS_NAME.CURATION_CATEGORY_TITLE}`}>
          <span>{curationWording}</span>
        </SectionTitle>
        <SectionContent className={`${CUSTOM_CLASS_NAME.CURATION_CATEGORY_CONTENTS}`}>
          {/* 스켈레톤 */}
          {skeleton}
          {/* 큐레이션 목록 */}
          {curationListEl}
        </SectionContent>
      </StyledSectionCuration>
    </SectionLayout>
  )
}

const StyledSectionCuration = styled.div`
  width: 100%;
  position: relative;
`
export default SectionCuration
